import {
    COST_CALC_REMOVE_ROW
} from './actionTypes';

export function rowDelete(rows) {
    return {
        type: COST_CALC_REMOVE_ROW,
        rows
    }
}